/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Permanent_HintInputs */



/**
* | output |
* | --- |
* | "Leave expiry empty for permanent ban" |
*
* @param {Sanction_Mgr_Permanent_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_permanent_hint = /** @type {((inputs?: Sanction_Mgr_Permanent_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Permanent_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Laissez l'expiration vide pour un bannissement permanent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deje la fecha de expiración vacía para suspensión permanente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deixe a expiração vazia para banimento permanente")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lascia vuota la scadenza per ban permanente")
	return /** @type {LocalizedString} */ ("Leave expiry empty for permanent ban")
});